export class InvalidProblemSpec extends Error {}
